export const MODAL_DATA = {
  EMAIL: {
    title: 'Enter your email address',
    description: 'We will send you a temporary code that is good for 3 minutes.'
  }
}
